module.exports = __webpack_public_path__ + "img/52114148_L.6404fb39.png";